// @ts-nocheck
import * as React from 'react';
import { NavMenu } from './NavMenu';
import $ from 'jquery';
import { PopupWindow } from './sharedcomponents/PopupWindow';
import animatedloader from '../images/animated-loader.gif';
import { initialize} from "bing-maps-loader";
var Config: any = require('../Config.json');

export default class AuthorizedLayout extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);
        
    }    

    componentDidMount() {
        var preloader = document.getElementById("preloader");
        preloader.classList.add("hidden"); 
        $('#globalLoader').hide();
        initialize(Config.BingMapsKey);
    }
 
    WithMenu() {
        return <div><NavMenu /><div>{this.props.children}</div></div>
    }

    public render() {
        PopupWindow.ClosePopup();
        return <div>
            <div id="globalLoader" style={{ pointerEvents: 'auto' }} className="loader-global"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
            <div>
                { this.WithMenu() }
            </div>
            <PopupWindow></PopupWindow>
            <div id='divMsboxDynamicContent'></div>
            <div id='divHomepagecontextcontainer'></div>
        </div>;
    }
}
